import React from "react";
import FromToRangeInput from "../input/FromToRangeInput";
import { useDispatch, useSelector } from "react-redux";
import { updateFilter } from "../../store/slices/filterSlice";

const Price = () => {
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  return (
    <div className="d-flex justify-content-center mt-3">
      <FromToRangeInput
        isDecimal
        // InputWidth={"300px"}
        fromLabel={"From"}
        toLabel={"To"}
        mainLabel={"Price"}
        fromValue={filterSelect?.minPrice}
        toValue={filterSelect?.maxPrice}
        onMinChange={(e) =>
          dispatch(
            updateFilter({ key: "minPrice", value: Number(e.target.value) })
          )
        }
        onMaxChange={(e) =>
          dispatch(
            updateFilter({ key: "maxPrice", value: Number(e.target.value) })
          )
        }
      />
    </div>
  );
};

export default Price;
